// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"a7902eee","114":"4f5079ad","624":"7aa65d9b"}[chunkId] + ".chunk.css";
};